// LogJob's phone/tablet bottom-bar layout: ONE ROW (KAN-1078). The total sits
// on the left as a stacked "label over amount" and the natural-width primary on
// the right, both inside `FullScreenActionRow`. (Before: two stacked rows, a
// label+amount line and a full-width button.)
import { foundation } from '../ui';
import { secondaryFigureStyle } from '../ui/figureType';

// KAN-1069: this sum is ONLY the first-paint fallback for the scroll reserve and the bar's minHeight
// floor - the live reserve is the bar's measured height (`--cvx-logjob-bar-h`, useBarHeightVar).
// ── LOGJOB_MOBILE_BAR_HEIGHT_PX ─────────────────────────────────────────
// The phone-only fixed `bottomBarMobile` bar's own rendered height (border-
// box, matching the app's global `* { box-sizing: border-box }` reset), so the
// scroll region's reserved clear-space (logJobStyles.js's `scrollWrapMobile`)
// can never drift from the bar it exists to keep content out from under:
//   bottomBarMobile.paddingTop                                    10
//   + the action row's phone floor (FULLSCREEN_BAR_ROW_MIN.phone,
//     the stacked total's measured height)                        57
//   + bottomBarMobile.paddingBottom (the 12px floor of max(12px, inset))  12
//   ------------------------------------------------------------------
//   = 79   (and 67 without the bottom padding -- LOGJOB_MOBILE_BAR_ABOVE_PAD_PX)
// The bar is a single row, so only the "why it is grey" note above the row
// can make it taller - and that is exactly what the measured var absorbs.
export const LOGJOB_MOBILE_BAR_HEIGHT_PX = 79;
export const LOGJOB_MOBILE_BAR_ABOVE_PAD_PX = LOGJOB_MOBILE_BAR_HEIGHT_PX - 12;

export const barStyles = {
  // The left slot: label (12px, muted) over the amount (22px, bold).
  leftTotal: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 },
  leftLabel: {
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: foundation.color.neutral.textMuted,
    fontWeight: foundation.fontWeight.medium,
    fontSize: foundation.fontSize.xs,
    fontFamily: foundation.fontFamily.sans,
  },
  leftAmount: {
    whiteSpace: 'nowrap',
    ...secondaryFigureStyle,
    color: foundation.color.neutral.text,
  },
};
